import { ProgressSpinner } from 'primereact/progressspinner';

export default function Loading() {
    return (
        <div className='flex justify-content-center'>
            <ProgressSpinner style={{width: '50px', height: '50px'}} animationDuration=".5s"/>
        </div>
    );
}